<!-- prettier-ignore -->

<div class="errorPage-container">

    <div class="info-wrapper">
        <div class="info-wrapper__text">
            <div style="display: flex; gap: .5rem;">
                @if(!isLicenseExpired()){
                    <span>{{'ERROR 404'}}</span>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.99992 10.6666V7.99992M7.99992 5.33325H8.00659M14.6666 7.99992C14.6666 11.6818 11.6818 14.6666 7.99992 14.6666C4.31802 14.6666 1.33325 11.6818 1.33325 7.99992C1.33325 4.31802 4.31802 1.33325 7.99992 1.33325C11.6818 1.33325 14.6666 4.31802 14.6666 7.99992Z" stroke="#E4626F" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                }
            </div>
            @if(!isAppLoaded()){
                @if(isLicenseExpired()){
                    <h1>{{'¡Vaya!' | translate}}</h1>
                    <p>{{'Esta página no está disponible, pero en iUrban estamos aquí para ayudarte.' | translate}}</p>
                    <strong>{{'Conoce ahora todo lo que Cicerone puede hacer por tí en nuestra web.' | translate}}</strong>
                }
                @else {
                    <h1>¡Oops!</h1>
                    <p>{{'La página que buscas no está aquí, pero yo te ayudaré a encontrar algo igual de interesante.' | translate}}</p>
                    <strong>{{'¿Qué te parece si exploramos juntos?' | translate}}</strong>
                }
            }
            @else{
                <h1>{{'¡Vaya!' | translate}}</h1>
                <p>{{'Parece que esta página ha tomado un desvío inesperado.' | translate}}</p>
                <strong>{{'¿Empezamos de nuevo?' | translate}}</strong>
            }
        </div>

        <div class="info-wrapper__action-buttons">
            @if(!isAppLoaded()){
                <button (click)="goToLanding()" [ngClass]="{'rounded': isLicenseExpired()}">{{'Conoce más en iUrban' | translate}}</button>
            }
            @else{
                <button (click)="goBack()">
                    <svg width="9" height="9" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.5 13L1.5 7L7.5 1" stroke="#F8F9FA" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    {{'Volver al inicio de la página' | translate}}
                </button>
            }
            @if(!isLicenseExpired()){
                <a href="mailto:info@iurban.es?subject=Error%20en%20la%20página&body=Hola,%20he%20encontrado%20un%20error...">{{'Reportar un error' | translate}}</a>   
            }
        </div>
    </div>

    <div class="image-wrapper">
        @if(isLicenseExpired()){
            <img draggable="false" src="/assets/imgs/expired-license-robot.webp" />
        }
       @else {
        <img draggable="false" src="/assets/imgs/404-robot-image.webp" />
       } 
    </div>

</div>